import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { useCallback, useRef } from 'react';
import RichTextField from 'components/shared/util/richTextField/containers/richTextField';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import styles from './conversationsBulkModalTextEditor.module.scss';
export const ConversationsBulkModalTextEditor = ({ type, onChange, }) => {
    const editorRef = useRef(null);
    const { writeHtmlEmail } = useFeatureFlag(['write-html-email']);
    const handleRenderTemplate = useCallback(({ content }) => {
        return Promise.resolve({ data: { rendered_content: content } });
    }, []);
    const handleChange = useCallback(() => {
        var _a, _b;
        onChange(((_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.getText()) || '', ((_b = editorRef.current) === null || _b === void 0 ? void 0 : _b.getPlainText()) || '');
    }, [onChange]);
    return (_jsx("div", Object.assign({ className: classnames(styles.container, {
            [styles.containerInternalNote]: type === 'add_internal_note',
        }) }, { children: _jsx(RichTextField
        // NOTE: Do it like this because there's something wrong with the typing.
        , Object.assign({}, { hasFFWriteHTMLEmail: writeHtmlEmail }, { ref: editorRef, renderTemplate: handleRenderTemplate, channel: "bulk", placeholder: type === 'add_internal_note'
                ? 'Type your internal note...'
                : 'Type your message...', onChange: handleChange })) })));
};
